import { FC, useCallback, useRef, useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import {
  Button,
  Heading,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  CircularProgress,
  Center,
  useToast,
  InputLeftAddon,
  InputGroup,
} from "@chakra-ui/react";
import { TableUsers } from "../../components/TableData";
import { useUserCreate } from "../../../user/hooks";
import { useToken } from "../../../auth/hooks";
import { PageHead } from "../../components/PageHead";

export const HomeScreen: FC = () => {
  const navigate = useNavigate();
  const [token] = useToken();
  const toast = useToast();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const phoneRef = useRef<HTMLInputElement>();
  const { createUserReq, userCreateLoading } = useUserCreate();

  const handleCloseModal = useCallback(() => setModalIsOpen(false), []);

  const handleOpenModal = useCallback(() => setModalIsOpen(true), []);

  const onSubmit = useCallback(async () => {
    const phone = phoneRef?.current?.value;
    if (phone) {
      const res = await createUserReq({ phone });
      if (res.data.success) {
        toast({
          title: "Пользователь создан ",
          description:
            "Пожалуйста заполните данные о пользователе следующим шагом",
          status: "success",
          duration: 9000,
          isClosable: true,
        });
        navigate(`/edit_user/${res?.data?.data?.id}`);
      }
    }
  }, []);

  if (token === null) {
    return <Navigate replace to="/login" />;
  }

  return (
    <>
      <PageHead
        breadCrumbs={<Heading>Клиенты</Heading>}
        onClick={handleOpenModal}
        linkLabel="+ Новый клиент"
      >
        <TableUsers />
      </PageHead>
      <Modal isOpen={modalIsOpen} onClose={handleCloseModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Регистрация пользователя</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {userCreateLoading ? (
              <Center>
                <CircularProgress isIndeterminate />
              </Center>
            ) : (
              <FormControl>
                <FormLabel>Телефон</FormLabel>
                <InputGroup>
                  <InputLeftAddon children="+" />
                  <Input ref={phoneRef} type="number" placeholder="Телефон" />
                </InputGroup>
              </FormControl>
            )}
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" onClick={handleCloseModal}>
              Отменить
            </Button>
            <Button
              disabled={userCreateLoading}
              colorScheme="blue"
              mr={3}
              onClick={onSubmit}
              marginLeft="20px"
            >
              Создать
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
